import CheckBox from '../../formComponents/CheckBox';
import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Notification from '../../formComponents/Notification';
import Select from 'react-select';
import UpdateMultiCheckBox from '../../formComponents/UpdateMultiCheckBox';

export default function NoteReferralUpdateForm({ params }) {
  let { authTokens, logoutUser, baseUrl, user } = useContext(AuthContext);

  /* state variables to hold json data from the back-end */
  const [categories, setCategories] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [academicBehaviorConcerns, setAcademicBehaviorConcerns] = useState([]);
  const [academicSkillsConcerns, setAcademicSkillsConcerns] = useState([]);
  const [socialBehaviorConcerns, setSocialBehaviorConcerns] = useState([]);
  const [previousDetails, setPreviousDetails] = useState();

  /* state variables to hold form data to submit to the back-end */
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState();
  const [issue, setIssue] = useState('');
  const [teacherActions, setTeacherActions] = useState('');
  const [isReferral, setIsReferral] = useState(false);
  const [
    selectedAcademicBehaviorConcerns,
    setSelectedAcademicBehaviorConcerns,
  ] = useState([]);
  const [
    selectedAcademicBehaviorConcernsIds,
    setSelectedAcademicBehaviorConcernsIds,
  ] = useState([]);
  const [selectedAcademicSkillsConcerns, setSelectedAcademicSkillsConcerns] =
    useState([]);
  const [
    selectedAcademicSkillsConcernsIds,
    setSelectedAcademicSkillsConcernsIds,
  ] = useState([]);
  const [academicComment, setAcademicComment] = useState('');
  const [selectedSocialBehaviorConcerns, setSelectedSocialBehaviorConcerns] =
    useState([]);
  const [
    selectedSocialBehaviorConcernsIds,
    setSelectedSocialBehaviorConcernsIds,
  ] = useState([]);
  const [behavioralComment, setBehavioralComment] = useState('');
  const [attendance, setAttendance] = useState(false);
  const [attendanceComment, setAttendanceComment] = useState('');
  const [parent, setParent] = useState(false);
  const [parentComment, setParentComment] = useState('');

  const [show, setShow] = useState(false);
  const [issueBorderColor, setIssueBorderColor] = useState('border-gray-300 ');
  const [issueLabelColor, setIssueLabelColor] = useState('text-brandText ');
  const [actionBorderColor, setActionBorderColor] =
    useState('border-gray-300 ');
  const [actionLabelColor, setActionLabelColor] = useState('text-brandText ');
  const [categoryBorderColor, setCategoryBorderColor] =
    useState('border-gray-300 ');
  const [categoryLabelColor, setCategoryLabelColor] =
    useState('text-brandText ');

  const validateFormData = (e) => {
    e.preventDefault();
    if (isReferral) {
      if (
        selectedPerson !== '' &&
        issue?.trim().length >= 1 &&
        teacherActions?.trim().length >= 1 &&
        selectedCategories?.length >= 1
      ) {
        setIssueLabelColor('text-brandText ');
        setIssueBorderColor('border-gray-300 ');
        setActionLabelColor('text-brandText ');
        setActionBorderColor('border-gray-300 ');
        handleSubmit(e);
      } else {
        setShow(true);
        if (issue?.trim().length < 1) {
          setIssueBorderColor('border-red-500 ');
          setIssueLabelColor('text-red-500 ');
        } else {
          setIssueBorderColor('border-gray-300 ');
          setIssueLabelColor('text-brandText ');
        }
        if (teacherActions?.trim().length < 1) {
          setActionBorderColor('border-red-500 ');
          setActionLabelColor('text-red-500 ');
        } else {
          setActionBorderColor('border-gray-300 ');
          setActionLabelColor('text-brandText ');
        }
        if (selectedCategories?.length < 1) {
          setCategoryLabelColor('text-red-500 ');
          setCategoryBorderColor('border-red-500 ');
        } else {
          setCategoryLabelColor('text-brandText ');
          setCategoryBorderColor('text-gray-300 ');
        }
      }
    } else {
      if (
        selectedPerson !== '' &&
        issue?.trim().length >= 1 &&
        teacherActions?.trim().length >= 1
      ) {
        setIssueLabelColor('text-brandText ');
        setIssueBorderColor('border-gray-300 ');
        setActionLabelColor('text-brandText ');
        setActionBorderColor('border-gray-300 ');
        handleSubmit(e);
      } else {
        setShow(true);
        if (issue?.trim().length < 1) {
          setIssueBorderColor('border-red-500 ');
          setIssueLabelColor('text-red-500 ');
        } else {
          setIssueBorderColor('border-gray-300 ');
          setIssueLabelColor('text-brandText ');
        }
        if (teacherActions?.trim().length < 1) {
          setActionBorderColor('border-red-500 ');
          setActionLabelColor('text-red-500 ');
        } else {
          setActionBorderColor('border-gray-300 ');
          setActionLabelColor('text-brandText ');
        }
      }
    }
  };

  useEffect(() => {
    getPreviousDetails();
    getCategories();
    getSubjects();
    getAcademicBehaviorConcerns();
    getAcademicSkillsConcerns();
    getSocialBehaviorConcerns();
  }, []);

  const navigate = useNavigate();

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response = await fetch(`${baseUrl}/mtss/referrals/${params}`, {
        method: 'Put',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
        body: JSON.stringify({
          student: selectedPerson?.id,
          issue: issue,
          teacher_actions: teacherActions,
          is_referral: isReferral,
          category: selectedCategories,
          subject: selectedSubjectIds,
          academic: selectedAcademicBehaviorConcernsIds,
          academic_skills: selectedAcademicSkillsConcernsIds,
          academic_comment: academicComment,
          behavioral: selectedSocialBehaviorConcernsIds,
          behavioral_comment: behavioralComment,
          attendance: attendance,
          attendance_comment: attendanceComment,
          parent: parent,
          parent_comment: parentComment,
        }),
      });

      let data = await response.json();

      if (response.status === 200) {
        navigate(-1);
      } else {
        setShow(true);
        console.log(data);

        let errorResponse = await fetch(`${baseUrl}/support/error-log/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: '/mtss/note-referral-update',
            district: baseUrl,
            user: user.name,
            error_description:
              'User failed to update the note/referral and received a status code.',
            response_text: JSON.stringify(data),
          }),
        });
      }
    } catch (error) {
      setShow(true);
      console.log(error);

      let errorResponse = await fetch(`${baseUrl}/support/error-log/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page: '/mtss/note-referral-update',
          district: baseUrl,
          user: user.name,
          error_description:
            'User failed to update the note/referral and received an error.',
          response_text: JSON.stringify(error),
        }),
      });
    }
  };

  let getPreviousDetails = async () => {
    let response = await fetch(`${baseUrl}/mtss/referrals/${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + String(authTokens.access),
      },
    });
    let data = await response.json();

    if (response.status === 200) {
      setPreviousDetails(data);
    } else if (response.statusText === 'Unauthorized') {
      logoutUser();
    }
  };

  let getCategories = async () => {
    let response = await fetch(`${baseUrl}/mtss/categories/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + String(authTokens.access),
      },
    });
    let data = await response.json();

    if (response.status === 200) {
      setCategories(data);
    } else if (response.statusText === 'Unauthorized') {
      logoutUser();
    }
  };

  let getSubjects = async () => {
    let response = await fetch(`${baseUrl}/mtss/subjects/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + String(authTokens.access),
      },
    });
    let data = await response.json();

    if (response.status === 200) {
      setSubjects(data);
    } else if (response.statusText === 'Unauthorized') {
      logoutUser();
    }
  };

  const getAcademicBehaviorConcerns = async () => {
    const response = await fetch(
      `${baseUrl}/mtss/concerns/?category__category_name=Academic+Behaviors`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    const data = await response.json();

    if (response.status === 200) {
      setAcademicBehaviorConcerns(data);
    } else if (response.statusText === 'Unauthorized') {
      logoutUser();
    }
  };

  const getAcademicSkillsConcerns = async () => {
    const response = await fetch(
      `${baseUrl}/mtss/concerns/?category__category_name=Academic+Skills`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    const data = await response.json();

    if (response.status === 200) {
      setAcademicSkillsConcerns(data);
    } else if (response.statusText === 'Unauthorized') {
      logoutUser();
    }
  };

  const getSocialBehaviorConcerns = async () => {
    const response = await fetch(
      `${baseUrl}/mtss/concerns/?category__category_name=Social+Behaviors`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    const data = await response.json();

    if (response.status === 200) {
      setSocialBehaviorConcerns(data);
    } else if (response.statusText === 'Unauthorized') {
      logoutUser();
    }
  };

  useEffect(() => {
    setSelectedSubjectIds([]);
    selectedSubjects?.forEach((object) => {
      setSelectedSubjectIds((selectedSubjectIds) => [
        ...selectedSubjectIds,
        `${object?.value}`,
      ]);
    });
    setSelectedAcademicBehaviorConcernsIds([]);
    selectedAcademicBehaviorConcerns?.forEach((object) => {
      setSelectedAcademicBehaviorConcernsIds(
        (selectedAcademicBehaviorConcernsIds) => [
          ...selectedAcademicBehaviorConcernsIds,
          `${object?.value}`,
        ],
      );
    });
    setSelectedAcademicSkillsConcernsIds([]);
    selectedAcademicSkillsConcerns?.forEach((object) => {
      setSelectedAcademicSkillsConcernsIds(
        (selectedAcademicSkillsConcernsIds) => [
          ...selectedAcademicSkillsConcernsIds,
          `${object?.value}`,
        ],
      );
    });
    setSelectedSocialBehaviorConcernsIds([]);
    selectedSocialBehaviorConcerns?.forEach((object) => {
      setSelectedSocialBehaviorConcernsIds(
        (selectedSocialBehaviorConcernsIds) => [
          ...selectedSocialBehaviorConcernsIds,
          `${object?.value}`,
        ],
      );
    });
  }, [
    selectedSubjects,
    selectedAcademicBehaviorConcerns,
    selectedAcademicSkillsConcerns,
    selectedSocialBehaviorConcerns,
  ]);

  useEffect(() => {
    setSelectedPerson(previousDetails?.student);
    setIssue(previousDetails?.issue);
    setTeacherActions(previousDetails?.teacher_actions);
    setIsReferral(previousDetails?.is_referral);
    setSelectedCategories(previousDetails?.category);
    setSelectedSubjects(previousDetails?.subject);
    setSelectedAcademicBehaviorConcerns(previousDetails?.academic);
    setSelectedAcademicSkillsConcerns(previousDetails?.academic_skills);
    setAcademicComment(previousDetails?.academic_comment);
    setSelectedSocialBehaviorConcerns(previousDetails?.behavioral);
    setBehavioralComment(previousDetails?.behavioral_comment);
    setAttendance(previousDetails?.attendance);
    setAttendanceComment(previousDetails?.attendance_comment);
    setParent(previousDetails?.parent);
    setParentComment(previousDetails?.parent_comment);

    setSelectedSubjectIds([]);
    selectedSubjects?.forEach((object) => {
      setSelectedSubjectIds((selectedSubjectIds) => [
        ...selectedSubjectIds,
        `${object?.value}`,
      ]);
    });
    setSelectedAcademicBehaviorConcernsIds([]);
    selectedAcademicBehaviorConcerns?.forEach((object) => {
      setSelectedAcademicBehaviorConcernsIds(
        (selectedAcademicBehaviorConcernsIds) => [
          ...selectedAcademicBehaviorConcernsIds,
          `${object?.value}`,
        ],
      );
    });
    setSelectedAcademicSkillsConcernsIds([]);
    selectedAcademicSkillsConcerns?.forEach((object) => {
      setSelectedAcademicSkillsConcernsIds(
        (selectedAcademicSkillsConcernsIds) => [
          ...selectedAcademicSkillsConcernsIds,
          `${object?.value}`,
        ],
      );
    });
    setSelectedSocialBehaviorConcernsIds([]);
    selectedSocialBehaviorConcerns?.forEach((object) => {
      setSelectedSocialBehaviorConcernsIds(
        (selectedSocialBehaviorConcernsIds) => [
          ...selectedSocialBehaviorConcernsIds,
          `${object?.value}`,
        ],
      );
    });
  }, [previousDetails]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isFocused ? 'white' : '#636363',
    }),
  };

  return (
    <section>
      <form
        className='mx-auto flex max-w-3xl flex-col space-y-8 px-4 py-12 text-brandText sm:py-16 sm:px-6 lg:px-8 lg:py-20'
        action=''
      >
        <div>
          <label
            htmlFor={'student'}
            className='block text-sm font-medium text-brandText'
          >
            Student*
          </label>
          <input
            className={`mt-1 block w-full rounded-md border-gray-300 text-brandText shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm`}
            type='text'
            disabled={true}
            value={`${selectedPerson?.first_name} ${selectedPerson?.last_name}`}
          />
        </div>
        <div>
          <label
            htmlFor='issue'
            className={`${issueLabelColor} block text-sm font-medium text-brandText`}
          >
            What is the issue?*
          </label>
          <div className='mt-1'>
            <textarea
              rows={4}
              name='issue'
              id='issue'
              onChange={(e) => setIssue(e.target.value)}
              value={issue}
              className={`${issueBorderColor} block w-full rounded-md border-gray-300 shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm`}
            />
          </div>
        </div>
        <div>
          <label
            htmlFor='teacher_actions'
            className={`${actionLabelColor} block text-sm font-medium text-brandText`}
          >
            What have you tried?*
          </label>
          <div className='mt-1'>
            <textarea
              rows={4}
              name='teacher_actions'
              id='teacher_actions'
              onChange={(e) => setTeacherActions(e.target.value)}
              className={`${actionBorderColor} block w-full rounded-md border-gray-300 shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm`}
              value={teacherActions}
            />
          </div>
        </div>
        <CheckBox
          srName={'Referral Checkbox'}
          id={'is_referral'}
          name={'is_referral'}
          text={'Check box for referral or leave blank for note'}
          textHint={''}
          isChecked={isReferral}
          setIsChecked={setIsReferral}
        />
        {isReferral ? (
          <div className='flex flex-col space-y-8'>
            <UpdateMultiCheckBox
              title={'Category*'}
              data={categories}
              setSelectedData={setSelectedCategories}
              dotName={'category_name'}
              labelColor={categoryLabelColor}
              borderColor={categoryBorderColor}
              previousData={previousDetails?.category}
            />
            <div>
              <label className='text-sm font-medium text-brandText'>
                Subject
              </label>
              <div className='mt-1'>
                <Select
                  defaultValue={selectedSubjects}
                  onChange={setSelectedSubjects}
                  options={subjects}
                  isClearable={true}
                  isMulti={true}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 6,
                    fontWeight: 500,
                    colors: {
                      ...theme.colors,
                      primary25: '#0CB2DA',
                      primary: '#0CB2DA',
                    },
                  })}
                  styles={customStyles}
                />
              </div>
            </div>
            <div>
              <label className='text-sm font-medium text-brandText'>
                Academic Behavior Concerns
              </label>
              <div className='mt-1'>
                <Select
                  defaultValue={selectedAcademicBehaviorConcerns}
                  onChange={setSelectedAcademicBehaviorConcerns}
                  options={academicBehaviorConcerns}
                  isClearable={true}
                  isMulti={true}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 6,
                    fontWeight: 500,
                    colors: {
                      ...theme.colors,
                      primary25: '#0CB2DA',
                      primary: '#0CB2DA',
                    },
                  })}
                  styles={customStyles}
                />
              </div>
            </div>
            <div>
              <label className='text-sm font-medium text-brandText'>
                Academic Skills Concerns
              </label>
              <div className='mt-1'>
                <Select
                  defaultValue={selectedAcademicSkillsConcerns}
                  onChange={setSelectedAcademicSkillsConcerns}
                  options={academicSkillsConcerns}
                  isClearable={true}
                  isMulti={true}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 6,
                    fontWeight: 500,
                    colors: {
                      ...theme.colors,
                      primary25: '#0CB2DA',
                      primary: '#0CB2DA',
                    },
                  })}
                  styles={customStyles}
                />
              </div>
            </div>
            <div>
              <label
                htmlFor='issue'
                className='block text-sm font-medium text-brandText'
              >
                Academic Comments
              </label>
              <div className='mt-1'>
                <textarea
                  rows={4}
                  name='academic_comment'
                  id='academic_comment'
                  onChange={(e) => setAcademicComment(e.target.value)}
                  value={academicComment}
                  className='block w-full rounded-md border-gray-300 shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm'
                />
              </div>
            </div>
            <div>
              <label className='text-sm font-medium text-brandText'>
                Behavioral Concerns
              </label>
              <div className='mt-1'>
                <Select
                  defaultValue={selectedSocialBehaviorConcerns}
                  onChange={setSelectedSocialBehaviorConcerns}
                  options={socialBehaviorConcerns}
                  isClearable={true}
                  isMulti={true}
                  isSearchable={false}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 6,
                    fontWeight: 500,
                    colors: {
                      ...theme.colors,
                      primary25: '#0CB2DA',
                      primary: '#0CB2DA',
                    },
                  })}
                  styles={customStyles}
                />
              </div>
            </div>
            {/* <UpdateMultiCheckBox
              title={'Behavioral Concerns'}
              hint={''}
              previousData={previousDetails?.behavioral}
              data={behavioral}
              setSelectedData={setSelectedBehavioral}
              dotName={'concern_name'}
            /> */}
            <div>
              <label
                htmlFor='issue'
                className='block text-sm font-medium text-brandText'
              >
                Behavioral Comments
              </label>
              <div className='mt-1'>
                <textarea
                  rows={4}
                  name='behavioral_comment'
                  id='behavioral_comment'
                  onChange={(e) => setBehavioralComment(e.target.value)}
                  value={behavioralComment}
                  className='block w-full rounded-md border-gray-300 shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm'
                />
              </div>
            </div>
            <CheckBox
              srName={'Attendance Checkbox'}
              id={'attendance'}
              name={'attendance'}
              text={'Is attendance a contributing factor to this issue?'}
              textHint={''}
              isChecked={attendance}
              setIsChecked={setAttendance}
            />
            <div>
              <label
                htmlFor='issue'
                className='block text-sm font-medium text-brandText'
              >
                Attendance Comments
              </label>
              <div className='mt-1'>
                <textarea
                  rows={4}
                  name='attendance_comments'
                  id='attendance_comments'
                  onChange={(e) => setAttendanceComment(e.target.value)}
                  value={attendanceComment}
                  className='block w-full rounded-md border-gray-300 shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm'
                />
              </div>
            </div>
            <CheckBox
              srName={'Parent Checkbox'}
              id={'parent'}
              name={'parent'}
              text={'Has the parent been contacted'}
              textHint={''}
              isChecked={parent}
              setIsChecked={setParent}
            />
            <div>
              <label
                htmlFor='issue'
                className='block text-sm font-medium text-brandText'
              >
                Please describe the dates and outcomes
              </label>
              <div className='mt-1'>
                <textarea
                  rows={4}
                  name='parent_comment'
                  id='parent_comment'
                  onChange={(e) => setParentComment(e.target.value)}
                  value={parentComment}
                  className='block w-full rounded-md border-gray-300 shadow-sm focus:border-brandPrimary focus:ring-brandPrimary sm:text-sm'
                />
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <button
          onClick={validateFormData}
          className='inline-flex w-full items-center justify-center rounded-md border border-transparent bg-brandPrimary px-6 py-3 text-base font-medium text-white shadow-sm duration-300 ease-in-out hover:scale-105 hover:bg-brandPrimaryLight focus:outline-none focus:ring-2 focus:ring-brandPrimary focus:ring-offset-2'
        >
          Submit
        </button>
      </form>
      <Notification
        success={false}
        show={show}
        setShow={setShow}
        messageOne={'Failed to submit form!'}
        messageTwo={
          'Please ensure that all fields and selections have been completed.'
        }
      />
    </section>
  );
}
